import { MutationCache, QueryClient } from "@tanstack/react-query";
import { CACHE } from "config/cachePolicy";
import { logError } from "services/logger";

/**
 * Defaults bias toward freshness (healthcare).
 * Override per-query with CACHE.SESSION / CATALOG / REFERENCE only for
 * data that is safe to sometimes be stale.
 */
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      logError({
        message: error?.message || "Mutation failed",
        context: {
          mutationKey: mutation.options.mutationKey,
        },
      });
      if (import.meta.env.DEV) {
        console.error(error);
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: CACHE.LIVE,
      retry: 1,
      // Returning to the tab should not show stale clinical data.
      refetchOnWindowFocus: true,
    },
  },
});
